export default __webpack_public_path__ + "static/media/level_1.a2096675.png";